import { isIP } from 'node:net';

export interface LookupOptions {
  all?: boolean;
}

export type LookupCallback = (
  error: NodeJS.ErrnoException | null,
  address: string | Array<{ address: string; family: number }>,
  family?: number,
) => void;

/**
 * DNS lookup that ignores the requested hostname and always returns the
 * address already validated for this connection. This is the DNS-rebinding pin.
 */
export function createPinnedLookup(ip: string): (hostname: string, options: LookupOptions, callback: LookupCallback) => void {
  const family = isIP(ip);
  if (family !== 4 && family !== 6) {
    throw new Error('Refusing to pin an invalid address.');
  }

  return (_hostname, options, callback) => {
    if (options.all) {
      callback(null, [{ address: ip, family }]);
      return;
    }
    callback(null, ip, family);
  };
}

export function createConnectOptions(ip: string, hostname: string, timeoutMs: number) {
  const normalizedHost = hostname.replace(/^\[|\]$/g, '');
  return {
    rejectUnauthorized: true,
    timeout: timeoutMs,
    servername: isIP(normalizedHost) ? undefined : normalizedHost,
    lookup: createPinnedLookup(ip),
  };
}
